import "./Css/ExamManagment.css";
import { useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE from "../config/api";

const API_URL = `${API_BASE}/api/Institutes`;

const InstitudeManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [examList, setExamList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);

  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const [cards, setCards] = useState({
    total: 0,
    active: 0,
    inactive: 0
  });

  /* ================= FETCH INSTITUTES ================= */
  const fetchInstitutes = async () => {
    try {
      const res = await axios.get(API_URL, {
        params: {
          page: currentPage,
          pageSize: rowsPerPage,
          search: searchQuery || null
        }
      });

      const mapped = res.data.data.map(x => ({
        id: x.id,
        inid: x.instituteUniqueId,
        inname: x.instituteName,
        name: x.softwares?.length
          ? x.softwares.map(s => s.name).join(", ")
          : "-",
        type: x.principleName,
        number: x.phoneNumber,
        techtotal: x.teachersCount,
        sudtotal: x.studentsCount,
        isActive: x.isActive
      }));

      setExamList(mapped);
      setTotalRecords(res.data.totalRecords);
    } catch (err) {
      console.error("Institute fetch error", err);
    }
  };

  /* ================= FETCH CARDS ================= */
  const fetchCards = async () => {
    try {
      const res = await axios.get(`${API_URL}/cards`);
      setCards({
        total: res.data.totalInstitutes,
        active: res.data.activeInstitutes,
        inactive: res.data.deactivatedInstitutes
      });
    } catch (err) {
      console.error("Cards fetch error", err);
    }
  };

  useEffect(() => {
    fetchInstitutes();
  }, [currentPage, rowsPerPage, searchQuery]);

  useEffect(() => {
    fetchCards();
  }, []);

  /* ================= ACTIONS ================= */
  const toggleStatus = async (id, currentStatus) => {
    try {
      await axios.put(
        `${API_URL}/${id}/status`,
        null,
        {
          params: {
            isActive: !currentStatus
          }
        }
      );

      fetchInstitutes();
      fetchCards();
    } catch (err) {
      console.error("Status toggle failed", err);
    }
  };

  const handleViewClick = (id) => {
    navigate(`/dashboard/institudeview/${id}`);
  };

  const handleEditClick = (id) => {
    navigate(`/dashboard/institudeedit/${id}`);
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowDeletePopup(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(`${API_URL}/${deleteId}`);
      fetchInstitutes();
      fetchCards();
    } catch (err) {
      console.error(err);
    } finally {
      setShowDeletePopup(false);
      setDeleteId(null);
    }
  };

  const cancelDelete = () => {
    setShowDeletePopup(false);
    setDeleteIndex(null);
  };

  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  return (
    <div className="exam-page">
      {/* Header */}
      <div className="exam-header">
        <h3>संस्था व्यवस्थापन</h3>
        <button
          className="primary-btn"
          onClick={() => navigate("/dashboard/institudeform")}
        >
          नवीन संस्था जोडा
        </button>
      </div>

      {/* Search */}
      <div className="filters">
        <div className="search-wrapper-exam">
          <input
            className="udises"
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>
      </div>

      {/* Stats */}
      <div className="stats">
        <div className="stat purple">
          <div>
            <h4>एकूण संस्था</h4>
            <p>{cards.total}</p>
          </div>
        </div>

        <div className="stat green">
          <div>
            <h4>सक्रिय संस्था</h4>
            <p>{cards.active}</p>
          </div>
        </div>

        <div className="stat blue">
          <div>
            <h4>निष्क्रिय संस्था</h4>
            <p>{cards.inactive}</p>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="table-card">
        <table>
          <thead>
            <tr>
              <th>क्र.</th>
              <th>संस्था ID</th>
              <th>संस्था नाव</th>
              <th>सॉफ्टवेअर</th>
              <th>मुख्याधापक नाव</th>
              <th>मोबाइल नंबर</th>
              <th>शिक्षक</th>
              <th>विद्यार्थी</th>
              <th>स्थिती</th>
              <th>क्रिया</th>
            </tr>
          </thead>
          <tbody>
            {examList.map((exam, index) => (
              <tr key={exam.id}>
                <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                <td>{exam.inid}</td>
                <td>{exam.inname}</td>
                <td>{exam.name}</td>
                <td>{exam.type}</td>
                <td>{exam.number}</td>
                <td>{exam.techtotal}</td>
                <td>{exam.sudtotal}</td>
                <td>
                  <span
                    onClick={() => toggleStatus(exam.id, exam.isActive)}
                    style={{ cursor: "pointer", display: "inline-block" }}
                  >
                    {!exam.isActive ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="45" height="24" viewBox="0 0 49 24" fill="none">
                        <g filter="url(#filter0_i_973_16000)">
                          <rect width="49" height="24" rx="12" fill="url(#paint0_linear_973_16000)" />
                        </g>
                        <circle cx="13" cy="12" r="9" fill="white" />
                        <defs>
                          <filter id="filter0_i_973_16000" x="0" y="0" width="49" height="24" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                            <feOffset />
                            <feGaussianBlur stdDeviation="2" />
                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_973_16000" />
                          </filter>
                          <linearGradient id="paint0_linear_973_16000" x1="37" y1="-11.5" x2="8.5" y2="20.5" gradientUnits="userSpaceOnUse">
                            <stop stop-color="white" />
                            <stop offset="1" stop-color="#B2C7FF" />
                          </linearGradient>
                        </defs>
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="45" height="29" viewBox="0 0 49 29" fill="none">
                        <g filter="url(#filter0_i_973_15988)">
                          <rect width="49" height="24" rx="12" fill="url(#paint0_linear_973_15988)" />
                        </g>
                        <g filter="url(#filter1_d_973_15988)">
                          <circle cx="35" cy="12" r="9" fill="white" />
                        </g>
                        <defs>
                          <filter id="filter0_i_973_15988" x="0" y="0" width="49" height="24" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                            <feOffset />
                            <feGaussianBlur stdDeviation="2" />
                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_973_15988" />
                          </filter>
                          <filter id="filter1_d_973_15988" x="22" y="3" width="26" height="26" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                            <feOffset dy="4" />
                            <feGaussianBlur stdDeviation="2" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_973_15988" />
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_973_15988" result="shape" />
                          </filter>
                          <linearGradient id="paint0_linear_973_15988" x1="12" y1="-8" x2="44.5" y2="24" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#78F0BA" />
                            <stop offset="0.158654" stop-color="#8FF0C4" />
                            <stop offset="0.509615" stop-color="#5BBBD4" />
                            <stop offset="0.629808" stop-color="#4B9FE3" />
                            <stop offset="1" stop-color="#2D68FE" />
                          </linearGradient>
                        </defs>
                      </svg>
                    )}
                  </span>
                </td>
                <td className="actions">
                  <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleViewClick(exam.id)} width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M12.0037 15.1538C13.0198 15.1538 13.8821 14.7981 14.5904 14.0868C15.2988 13.3754 15.6529 12.5117 15.6529 11.4955C15.6529 10.4793 15.2973 9.61708 14.5859 8.90875C13.8746 8.20042 13.0108 7.84625 11.9947 7.84625C10.9785 7.84625 10.1163 8.20192 9.40792 8.91325C8.69959 9.62458 8.34542 10.4883 8.34542 11.5045C8.34542 12.5207 8.70109 13.3829 9.41242 14.0913C10.1238 14.7996 10.9875 15.1538 12.0037 15.1538ZM11.9992 14.2C11.2492 14.2 10.6117 13.9375 10.0867 13.4125C9.56167 12.8875 9.29917 12.25 9.29917 11.5C9.29917 10.75 9.56167 10.1125 10.0867 9.5875C10.6117 9.0625 11.2492 8.8 11.9992 8.8C12.7492 8.8 13.3867 9.0625 13.9117 9.5875C14.4367 10.1125 14.6992 10.75 14.6992 11.5C14.6992 12.25 14.4367 12.8875 13.9117 13.4125C13.3867 13.9375 12.7492 14.2 11.9992 14.2ZM12.0019 18C9.83592 18 7.86192 17.4106 6.07992 16.2317C4.29792 15.0529 2.96334 13.4757 2.07617 11.5C2.96334 9.52433 4.29701 7.94708 6.07717 6.76825C7.85734 5.58942 9.83042 5 11.9964 5C14.1624 5 16.1364 5.58942 17.9184 6.76825C19.7004 7.94708 21.035 9.52433 21.9222 11.5C21.035 13.4757 19.7013 15.0529 17.9212 16.2317C16.141 17.4106 14.1679 18 12.0019 18Z" fill="#313030" />
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleEditClick(exam.id)} width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M5.02607 19.9157C4.74007 19.9734 4.49674 19.9019 4.29607 19.7014C4.09557 19.5008 4.02415 19.2574 4.08182 18.9714L4.72607 15.8369L8.16057 19.2714L5.02607 19.9157ZM8.92032 18.6234L5.37407 15.0772L15.7376 4.73294C16.0439 4.4266 16.4227 4.27344 16.8741 4.27344C17.3254 4.27344 17.7042 4.4266 18.0106 4.73294L19.2646 5.98694C19.5709 6.29327 19.7241 6.6721 19.7241 7.12344C19.7241 7.57477 19.5709 7.9536 19.2646 8.25994L8.92032 18.6234Z" fill="#4285F4" />
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleDeleteClick(exam.id)} width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M7.6155 20.0036C7.15517 20.0036 6.77083 19.8495 6.4625 19.5411C6.15417 19.2328 6 18.8485 6 18.3881V6.00363H5V5.00363H9V4.23438H15V5.00363H19V6.00363H18V18.3881C18 18.8485 17.8458 19.2328 17.5375 19.5411C17.2292 19.8495 16.8448 20.0036 16.3845 20.0036H7.6155ZM9.80775 17.0036H10.8078V8.00363H9.80775V17.0036ZM13.1923 17.0036H14.1923V8.00363H13.1923V17.0036Z" fill="#FF1501" />
                  </svg>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Delete Popup */}
      {showDeletePopup && (
        <div className="delete-popup-overlay" onClick={cancelDelete}>
          <div className="delete-popup-boxx" onClick={(e) => e.stopPropagation()}>
            <h3>संस्था हटवायची खात्री आहे का?</h3>
            <div className="delete-popup-buttons">
              <button onClick={cancelDelete}>नाही</button>
              <button onClick={confirmDelete}>होय</button>
            </div>
          </div>
        </div>
      )}

      {/* Pagination */}
      <div className='que-pagination-container'>
        <div className="que-pagination-controlss">
          <button
            className="que-pagination-btn"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            &lt;
          </button>

          {[...Array(totalPages).keys()]
            .map((_, i) => i + 1)
            .slice(
              Math.max(currentPage - 2, 0),
              Math.min(currentPage + 1, totalPages)
            )
            .map((page) => (
              <button
                key={page}
                className={`que-pagination-btn ${currentPage === page ? 'active' : ''
                  }`}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </button>
            ))}

          <button
            className="que-pagination-btn"
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            &gt;
          </button>
          {/* Rows per page and range info */}
          <div className="que-pagination-controls">
            <span className="que-rows-label">Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
              className="que-rows-dropdown"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstitudeManagement;
